var map = {
	"./tipocontacto01.svg": 1427,
	"./tipocontacto010.svg": 1428,
	"./tipocontacto011.svg": 1429,
	"./tipocontacto012.svg": 1430,
	"./tipocontacto02.svg": 1431,
	"./tipocontacto03.svg": 1432,
	"./tipocontacto04.svg": 1433,
	"./tipocontacto05.svg": 1434,
	"./tipocontacto06.svg": 1435,
	"./tipocontacto07.svg": 1436,
	"./tipocontacto08.svg": 1437,
	"./tipocontacto09.svg": 1438
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 364;